import React, { useEffect, useState } from "react";
import StepperComponent from "@/components/stepper";
import { FaAddressCard, FaMoneyBillWave, FaUser } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";

import CandidateDetails from "./CandidateDetails";
import OfferDetails from "./OfferDetails";
import OfferModeller from "./OfferModeller";
import { useTypedSelector } from "@hooks";
import { offersApi, useFetchOfferByIdQuery, useLazyFetchAutoPopulateDataQuery } from "@/services";
import { useParams } from "react-router-dom";
import { handleStage } from "@/store/offers";
import { AISuggestionBot } from "@/components/AISuggestionBot";
import { Checkbox } from "antd";
import { roles } from "@/constants";

const steps = [
  {
    title: "Offer Details",
    icon: <FaAddressCard size={18} />,
  },
  {
    title: "Candidate Details",
    icon: <FaUser size={18} />,
  },
  {
    title: "Offer Modeler",
    icon: <FaMoneyBillWave size={18} />,
  },
];

const components: any = {
  POSITION_DETAILS: <OfferDetails />,
  CANDIDATE_DETAILS: <CandidateDetails />,
  OFFER_MODELLER: <OfferModeller />,
};

const stageToStepIndex = {
  POSITION_DETAILS: 0,
  CANDIDATE_DETAILS: 1,
  OFFER_MODELLER: 2,
};

const AddOffer: React.FC<{ visible: boolean }> = () => {
  const { search } = useLocation();
  const location = useLocation();
  const isRevised = search === "?mode=revise";
  const dispatch = useDispatch();
  const history = useHistory();
  const [visible, setVisible] = useState(true);
  const [showAiSuggestion, setshowAiSuggestion] = useState(false);

  const [savedStep, setSavedStep] = useState({ state: false });
  const { offer_id } = useParams();
  const id = offer_id?.split("?")[0]; // 🔥 MUST
  const { company, role } = useTypedSelector(state => state.auth?.user!);
  const { id: company_id } = company!;
  const { offer: localOffer } = useTypedSelector(state => state.offers);
  const stage = localOffer?.stage;
  const is_create = window.location.pathname.includes("/create");

  const readOnly =
    localOffer && localOffer?.status !== "DRAFTED" && !isRevised
      ? true
      : false;

  const [showBanner, setShowBanner] = useState(false);
  const [fingerprint, setFingerprint] = useState(null);


  // const readOnly =
  //   localOffer && localOffer?.status !== "DRAFTED" && !isRevised ? true : false;

  const [triggerAutoPopulate] = useLazyFetchAutoPopulateDataQuery();


  const handleFetchLatest = async () => {
    try {
      console.log(id, company_id, "dd")
      await triggerAutoPopulate({ company_id, offer_id: id, manual: true });

      // nothing else needed for data update
      setShowBanner(false);
    } catch (err) {
      console.error(err);
    }
  };

  const { data: offerData } = useFetchOfferByIdQuery(
    { company_id, id },
    { skip: is_create }
  );

  const allowanceStatus = offerData?.data?.allowance_data_status;
  const initialFingerprint = offerData?.data?.allowance_data_fingerprint;

  useEffect(() => {
    if (offerData?.data) {
      const status = offerData.data.allowance_data_status;

      setShowBanner(!readOnly && status?.has_updates === true);

      setFingerprint(
        offerData.data.allowance_data_fingerprint ||
        status?.saved_fingerprint ||
        null
      );
    }
  }, [offerData, readOnly]);

  useEffect(() => {
    if (!is_create) {
      dispatch(
        offersApi.endpoints.fetchOfferById.initiate(
          {
            company_id,
            id,
          },
          {
            subscribe: false,
            forceRefetch: true,
          }
        )
      );
    }
    // return () => {
    //   dispatch(resetOffers());
    // };
  }, [company_id, dispatch, id, is_create]);

  const initialStep = stage ? stageToStepIndex[stage] : 0;
  const [currentStep, setCurrentStep] = useState(initialStep);

  const handleStepClick = (stepIndex: any) => {
    setCurrentStep(stepIndex);
    if (stepIndex === 0) {
      dispatch(handleStage("POSITION_DETAILS"));
    } else if (stepIndex === 1) {
      dispatch(handleStage("CANDIDATE_DETAILS"));
    } else if (stepIndex === 2) {
      dispatch(handleStage("OFFER_MODELLER"));
    }
  };

  const renderComponent = () => {
    switch (stage) {
      case "POSITION_DETAILS":
        return <OfferDetails onResponse={handleStepClick} />;
      case "CANDIDATE_DETAILS":
        return <CandidateDetails onResponse={handleStepClick} />;
      case "OFFER_MODELLER":
        return <OfferModeller onResponse={handleStepClick} />;
      default:
        return null;
    }
  };
  useEffect(() => {
    const queryString = location?.pathname?.includes("?")
      ? location?.pathname?.split("?")[1]
      : location?.search?.slice(1);

    if (!queryString) return;

    // 2. Parse query string
    const params = new URLSearchParams(queryString);

    // 3. Get first param name and value
    const paramNames = Array?.from(params.keys());
    if (paramNames.length > 0) {
      const name = paramNames[0]; // "step"
      const value = params.get(name); // "1"
      if (name == "step") {
        setSavedStep({ state: value == "1" || value == "2" });
      }
    }
  }, [location.pathname, location.search]);
  return (
    <>
      {visible && (
        <div className="overflow-x-hidden flex justify-center bg-white transition-all delay-75 overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none px-16 no-scrollbar">
          {!readOnly && showBanner && (
            <div className="bg-revampBlue fixed left-0 w-full z-50 right-2 border p-2 px-4 shadow-sm mb-6 flex justify-between items-center">
              <p className="text-sm text-white">
                {allowanceStatus?.message ||
                  "Allowance data for this Grade and Country has been updated."}
              </p>

              <button
                onClick={handleFetchLatest}
                className="bg-white text-xs text-revampBlue px-4 py-2 rounded shadow-sm border-white font-semibold"
              >
                Fetch Latest Data
              </button>
            </div>
          )}
          <div className="relative my-10 mx-6 py-5 w-full">
            <div className="Stepper w-6/12 mx-auto">
              <StepperComponent
                steps={steps}
                currentStep={currentStep}
                onStepClick={handleStepClick}
              />
            </div>
            <div className="border-0 mt-5 h-4/5 overflow-x-hidden overflow-scroll rounded-lg relative flex flex-col w-full outline-none focus:outline-none px-2">
              <div className="relative flex-auto">

                <div className="content">
                  {currentStep === 0 ? (
                    <div className=" p-5 bg-revampLightBlueBackground">
                      <p className="font-bold text-2xl text-gray-600  text-center mb-8">
                        Offered Position Details
                      </p>
                      {localOffer ? renderComponent() : <OfferDetails />}
                    </div>
                  ) : currentStep === 1 ? (
                    <div className=" p-5 bg-revampLightBlueBackground">
                      <p className="font-bold text-2xl text-center text-gray-600 mb-8">
                        Candidate Details
                      </p>
                      {localOffer ? renderComponent() : <CandidateDetails />}
                    </div>
                  ) : currentStep === 2 ? (
                    <div className="bg-white">
                      {localOffer ? (
                        renderComponent()
                      ) : (
                        <OfferModeller
                          offerModeller={false}
                          detailedView={false}
                        />
                      )}
                    </div>
                  ) : null}
                </div>
              </div>

              {/* <div className="flex items-center   justify-around p-6 border-t border-solid border-blueGray-200 rounded-b">
                <CustomButton
                  customClasses="!px-10  py-3 w-3/12 font-semibold"
                  btnName={"Continue"}
                  // onClick={current === 0 ? next : onSubmit}
                  onClick={handleNext}
                />
                <CustomButton
                  btnName="Go Back"
                  onClick={handlePrevious}
                  customClasses="!px-10 py-3  w-3/12 bg-themeButtonGray text-themeBlack font-semibold"
                  textStyles="font-semibold"
                />
              </div> */}
            </div>
          </div>

          {!savedStep?.state &&
            stage == "OFFER_MODELLER" &&
            !roles?.rolesThatCantAccessAiInsights.includes(role) && (
              <AISuggestionBot />
            )}
        </div>
      )}
    </>
  );
};

export default AddOffer;
